class Util {

  setLocale(locale) {
    return sessionStorage.setItem("locale", locale);
  }

  getDefaultLocale() {
    // console.log("Current TimeZone", Intl.DateTimeFormat().resolvedOptions().timeZone);
    let language = navigator.language;

    // if (language.startsWith("ko")) {
    //   language = "ko";
    // } else {
    //   language = "en";
    // }
    /* 2024.08.08 수정*/
    if (language.startsWith("ko")) {
      language = "ko";
    } else if (language.startsWith("en")) {
      language = "en";
    } else {
      language = "vi";
    }

    return language;
  }

  getLocale() {
    return sessionStorage.getItem("locale") ?? this.getDefaultLocale();
  }
  
}

export default new Util()